<template>
    <div>
        <vc-left-menu></vc-left-menu>

        <div :class="{ 'layout-content': true, 'is-active': !getMenuToggle }">
            <div class="page-header-container">
                <div class="page-header clearfix">
                    <h3 class="page-title">{{ $t('words.member_manage') }}</h3>
                </div>
            </div>
            <div class="module">
                <div class="module-header">
                    <h5 class="module-title">{{ $t('words.user_info')}}</h5>
                </div>
                <div class="module-body module-body-table">
                    <table class="table table-wide">
                        <thead>
                        <tr>
                            <th>{{ $t('words.name') }}</th>
                            <th>{{ $t('words.email') }}</th>
                            <th>{{ $t('words.role') }}</th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody v-if="members.load && (members.data.length !== 0)">
                        <tr v-for="member in members.data" :key="member.id">
                            <td>{{ member.name }}</td>
                            <td>{{ member.email }}</td>
                            <td>
                                <div  v-if="getLoginAccount.email !== member.email && haveOwnerRight">
                                    <select class="form-control" v-model="member.role_id" @change="doChangeRole(member)" >
                                        <option v-for="item in roles" :value="item.id" v-html="$t('words.role_' + item.name)" :key="item.id"></option>
                                    </select>
                                </div>
                                <div v-else>
                                    {{ $t('words.role_' + findRoleName(member.role_id)) }}
                                </div>
                            </td>
                            <td class="td__minimize actions">
                                <i class="btn btn-icon btn-flat" @click.prevent="doRemove(member)" v-if="getLoginAccount.email !== member.email && haveOwnerRight"><i class="icon icon-trash"></i></i>
                            </td>
                        </tr>
                        </tbody>
                        <tbody v-else-if="members.load">
                        <tr>
                            <td colspan="9" class="td__message">
                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24" class="svg-icon svg-icon-alert-circle"><g stroke-linecap="square" stroke-linejoin="miter" stroke-width="2" fill="#adb5bd" stroke="#adb5bd"><circle fill="none" stroke="#adb5bd" stroke-miterlimit="10" cx="12" cy="12" r="11"/> <line data-color="color-2" fill="none" stroke-miterlimit="10" x1="12" y1="7" x2="12" y2="13"/> <circle data-color="color-2" data-stroke="none" cx="12" cy="17" r="1" stroke-linejoin="miter" stroke-linecap="square" stroke="none"/></g></svg>{{ $t('paragraphs.members_empty') }}</td>
                        </tr>
                        </tbody>
                        <tbody v-else>
                        <tr>
                            <td colspan="9" class="td__message"><div class="loader"></div>{{ $t('paragraphs.list_loading') }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="module">
                <div class="module-header">
                    <h5 class="module-title">{{ $t('words.creators_per_channels_manage')}}</h5>
                </div>
                <div class="module-body">
                    <p class="text-guide">{{ $t('paragraphs.creators_per_channels_manage_tip1') }}<br>{{ $t('paragraphs.creators_per_channels_manage_tip2') }}</p>

                    <div class="action-group">
                        <a class="btn mr-auto" :href="getExportUri"><i class="icon icon-download"></i>{{ $t('words.download') }}</a>
                        <nav aria-label="Page navigation" class="ml-auto">
                            <ul class="pagination">
                                <li class="page-info">
                                    {{ $t('paragraphs.page_navigation', { total: channels.meta.total, from: ((channels.meta.current_page - 1) * channels.meta.per_page + 1), to: (channels.meta.current_page === channels.meta.last_page ? channels.meta.total : channels.meta.per_page * channels.meta.current_page)}) }}
                                </li>
                                <li :class="{'page-item': true, disabled: !channels.links.prev }">
                                    <button class="page-link" aria-label="Previous" @click="loadChannels(channels.links.prev)" v-if="channels.links.prev">
                                        <i class="icon icon-arrow-left-sm" aria-hidden="true"></i>
                                        <span class="sr-only">{{ $t('pagination.previous') }}</span>
                                    </button>
                                    <button class="page-link" aria-label="Previous" v-else>
                                        <i class="icon icon-arrow-left-sm" aria-hidden="true"></i>
                                        <span class="sr-only">{{ $t('pagination.previous') }}</span>
                                    </button>
                                </li>
                                <li :class="{'page-item': true, disabled: !channels.links.next }">
                                    <button class="page-link" aria-label="Next" @click="loadChannels(channels.links.next)" v-if="channels.links.next">
                                        <i class="icon icon-arrow-right-sm" aria-hidden="true"></i>
                                        <span class="sr-only">{{ $t('pagination.next') }}</span>
                                    </button>
                                    <button class="page-link disabled" aria-label="Previous" disabled v-else>
                                        <i class="icon icon-arrow-right-sm" aria-hidden="true"></i>
                                        <span class="sr-only">{{ $t('pagination.next') }}</span>
                                    </button>
                                </li>
                            </ul>
                        </nav>
                    </div>

                    <div class="table__wide">
                        <table class="table">
                            <thead>
                            <tr>
                                <th class="td__checkbox">No.</th>
                                <th>{{ $t('words.channel_key') }}
                                    <i :class="{'sortable':true, 'fa':true, 'fa-sort':true, 'fa-sort-up':list_conditions.order === 'key_asc'}" v-if="list_conditions.order === 'key_asc'" @click="changeOrder('key_desc')"></i>
                                    <i :class="{'sortable':true, 'fa':true, 'fa-sort':true, 'fa-sort-down':list_conditions.order === 'key_desc'}" v-else-if="list_conditions.order === 'key_desc'" @click="changeOrder('key_asc')"></i>
                                    <i :class="{'sortable':true, 'fa':true, 'fa-sort':true}" v-else @click="changeOrder('key_desc')"></i></th>
                                <th>{{ $t('words.customer_code') }}
                                    <i :class="{'sortable':true, 'fa':true, 'fa-sort':true, 'fa-sort-up':list_conditions.order === 'customer_code_asc'}" v-if="list_conditions.order === 'customer_code_asc'" @click="changeOrder('customer_code_desc')"></i>
                                    <i :class="{'sortable':true, 'fa':true, 'fa-sort':true, 'fa-sort-down':list_conditions.order === 'customer_code_desc'}" v-else-if="list_conditions.order === 'customer_code_desc'" @click="changeOrder('customer_code_asc')"></i>
                                    <i :class="{'sortable':true, 'fa':true, 'fa-sort':true}" v-else @click="changeOrder('customer_code_desc')"></i></th>
                                <th>{{ $t('words.channel_name') }}
                                    <i :class="{'sortable':true, 'fa':true, 'fa-sort':true, 'fa-sort-up':list_conditions.order === 'title_asc'}" v-if="list_conditions.order === 'title_asc'" @click="changeOrder('title_desc')"></i>
                                    <i :class="{'sortable':true, 'fa':true, 'fa-sort':true, 'fa-sort-down':list_conditions.order === 'title_desc'}" v-else-if="list_conditions.order === 'title_desc'" @click="changeOrder('title_asc')"></i>
                                    <i :class="{'sortable':true, 'fa':true, 'fa-sort':true}" v-else @click="changeOrder('title_desc')"></i></th>
                                <th>{{ $t('words.creator_nickname') }}</th>
                                <th>{{ $t('words.creator_code') }}</th>
                                <th>{{ $t('words.creator_stream_key') }}</th>
                            </tr>
                            </thead>
                            <tbody v-if="channels.load && (channels.meta.total !== 0)">
                            <tr v-for="(channel, index) in channels.data" :key="channel.live_media_channel_id">
                                <td class="td__checkbox">{{ ((channels.meta.current_page - 1) * channels.meta.per_page + 1) + index }}</td>
                                <td>{{ channel.key }}</td>
                                <td>{{ channel.customer_code }}</td>
                                <td>
                                    <a :href="`/channels/${channel.live_media_channel_id}/edit`" class="list__channel__name text-link" target="_new" :title="channel.title">
                                        {{ channel.title }}
                                    </a>
                                </td>
                                <td>
                                    <span v-if="channel.creator_nickname !== 'undefined'" class="label__create">{{ channel.creator_nickname }}</span>
                                </td>
                                <td>
                                    <span v-if="channel.creator_code !== 'undefined'" class="label__create">{{ channel.creator_code }}</span>
                                </td>
                                <td>
                                    <span v-if="channel.creator_stream_key !== 'undefined'" class="label__create">{{ channel.creator_stream_key }}</span>
                                </td>
                            </tr>
                            </tbody>
                            <tbody v-else-if="channels.load">
                            <tr>
                                <td colspan="7" class="td__message">
                                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24" class="svg-icon svg-icon-alert-circle"><g stroke-linecap="square" stroke-linejoin="miter" stroke-width="2" fill="#adb5bd" stroke="#adb5bd"><circle fill="none" stroke="#adb5bd" stroke-miterlimit="10" cx="12" cy="12" r="11"/> <line data-color="color-2" fill="none" stroke-miterlimit="10" x1="12" y1="7" x2="12" y2="13"/> <circle data-color="color-2" data-stroke="none" cx="12" cy="17" r="1" stroke-linejoin="miter" stroke-linecap="square" stroke="none"/></g></svg>{{ $t('paragraphs.list_empty') }}</td>
                            </tr>
                            </tbody>
                            <tbody v-else>
                            <tr>
                                <td colspan="7" class="td__message"><div class="loader"></div>{{ $t('paragraphs.list_loading') }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>

                </div>
            </div>

            <div class="module">
                <div class="module-header">
                    <h5 class="module-title">{{ $t('words.kollus_live_role_guide')}}</h5>
                </div>
                <div class="module-body">
                    <div class="table-responsive">
                        <table class="table table__guide">
                            <thead>
                            <tr>
                                <th rowspan="2">{{ $t('words.menu') }}</th>
                                <th colspan="2" rowspan="2">{{ $t('words.detail_function') }}</th>
                                <th colspan="2">{{ $t('words.role_creator') }}</th>
                                <th colspan="2">{{ $t('words.role_viewer') }}</th>
                                <th colspan="2">{{ $t('words.role_manager') }}</th>
                                <th colspan="2">{{ $t('words.role_owner') }}</th>
                            </tr>
                            <tr>
                                <th>{{ $t('words.view') }}</th>
                                <th>{{ $t('words.modify') }}</th>
                                <th>{{ $t('words.view') }}</th>
                                <th>{{ $t('words.modify') }}</th>
                                <th>{{ $t('words.view') }}</th>
                                <th>{{ $t('words.modify') }}</th>
                                <th>{{ $t('words.view') }}</th>
                                <th>{{ $t('words.modify') }}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td rowspan="9">
                                    {{ $t('words.channel_manage') }}
                                </td>
                                <td colspan="2">
                                    {{ $t('words.channel_list') }}
                                </td>
                                <td colspan="2" class="text-center"><i class="icon icon-close"></i></td>
                                <td colspan="2" class="text-center"><i class="icon icon-check"></i></td>
                                <td colspan="2" class="text-center"><i class="icon icon-check"></i></td>
                                <td colspan="2" class="text-center"><i class="icon icon-check"></i></td>
                            </tr>
                            <tr>
                                <td colspan="2">{{ $t('words.create_channel') }}</td>
                                <td colspan="2"><i class="icon icon-close"></i></td>
                                <td colspan="2"><i class="icon icon-close"></i></td>
                                <td colspan="2"><i class="icon icon-close"></i></td>
                                <td colspan="2"><i class="icon icon-check"></i></td>
                            </tr>
                            <tr>
                                <td colspan="2">{{ $t('words.channel_edit') }}</td>
                                <td colspan="2"><i class="icon icon-close"></i></td>
                                <td><i class="icon icon-check"></i></td>
                                <td><i class="icon icon-close"></i></td>
                                <td colspan="2"><i class="icon icon-check"></i></td>
                                <td colspan="2"><i class="icon icon-check"></i></td>
                            </tr>
                            <tr>
                                <td colspan="2">{{ $t('words.channel_hide/restore') }}</td>
                                <td colspan="2"><i class="icon icon-close"></i></td>
                                <td colspan="2"><i class="icon icon-close"></i></td>
                                <td colspan="2"><i class="icon icon-close"></i></td>
                                <td colspan="2"><i class="icon icon-check"></i></td>
                            </tr>
                            <tr>
                                <td colspan="2">{{ $t('words.remove_channels') }}</td>
                                <td colspan="2"><i class="icon icon-close"></i></td>
                                <td colspan="2"><i class="icon icon-close"></i></td>
                                <td colspan="2"><i class="icon icon-close"></i></td>
                                <td colspan="2"><i class="icon icon-check"></i></td>
                            </tr>
                            <tr>
                                <td rowspan="4">{{ $t('words.channel_detail') }}</td>
                                <td>{{ $t('words.mnu_live')}}</td>
                                <td colspan="2"><i class="icon icon-check"></i></td>
                                <td colspan="2"><i class="icon icon-close"></i></td>
                                <td colspan="2"><i class="icon icon-close"></i></td>
                                <td colspan="2"><i class="icon icon-close"></i></td>
                            </tr>
                            <tr>
                                <td>{{ $t('words.recording_file_download')}}</td>
                                <td colspan="2"><i class="icon icon-check"></i></td>
                                <td colspan="2"><i class="icon icon-check"></i></td>
                                <td colspan="2"><i class="icon icon-check"></i></td>
                                <td colspan="2"><i class="icon icon-check"></i></td>
                            </tr>
                            <tr>
                                <td>{{ $t('words.recording_file_remove')}}</td>
                                <td colspan="2"><i class="icon icon-close"></i></td>
                                <td colspan="2"><i class="icon icon-close"></i></td>
                                <td colspan="2"><i class="icon icon-check"></i></td>
                                <td colspan="2"><i class="icon icon-check"></i></td>
                            </tr>
                            <tr>
                                <td>{{ $t('words.live_info_desc')}}</td>
                                <td colspan="2"><i class="icon icon-check"></i></td>
                                <td colspan="2"><i class="icon icon-check"></i></td>
                                <td colspan="2"><i class="icon icon-check"></i></td>
                                <td colspan="2"><i class="icon icon-check"></i></td>
                            </tr>
                            <tr>
                                <td colspan="3">{{ $t('words.recording_files') }}</td>
                                <td colspan="2"><i class="icon icon-close"></i></td>
                                <td colspan="2"><i class="icon icon-check"></i></td>
                                <td colspan="2"><i class="icon icon-check"></i></td>
                                <td colspan="2"><i class="icon icon-check"></i></td>
                            </tr>
                            <tr>
                                <td rowspan="4">{{ $t('words.statistics_manage') }}</td>
                                <td colspan="2">{{ $t('words.statistics_channel') }}</td>
                                <td colspan="2"><i class="icon icon-close"></i></td>
                                <td colspan="2"><i class="icon icon-close"></i></td>
                                <td colspan="2"><i class="icon icon-check"></i></td>
                                <td colspan="2"><i class="icon icon-check"></i></td>
                            </tr>
                            <tr>
                                <td colspan="2">{{ $t('words.statistics_viewer_env') }}</td>
                                <td colspan="2"><i class="icon icon-close"></i></td>
                                <td colspan="2"><i class="icon icon-close"></i></td>
                                <td colspan="2"><i class="icon icon-check"></i></td>
                                <td colspan="2"><i class="icon icon-check"></i></td>
                            </tr>
                            <tr>
                                <td colspan="2">{{ $t('words.storage_usage') }}</td>
                                <td colspan="2"><i class="icon icon-close"></i></td>
                                <td colspan="2"><i class="icon icon-close"></i></td>
                                <td colspan="2"><i class="icon icon-check"></i></td>
                                <td colspan="2"><i class="icon icon-check"></i></td>
                            </tr>
                            <tr>
                                <td colspan="2">{{ $t('words.service_logs') }}</td>
                                <td colspan="2"><i class="icon icon-close"></i></td>
                                <td colspan="2"><i class="icon icon-check"></i></td>
                                <td colspan="2"><i class="icon icon-check"></i></td>
                                <td colspan="2"><i class="icon icon-check"></i></td>
                            </tr>
                            <tr>
                                <td rowspan="5">{{ $t('words.preference') }}</td>
                                <td rowspan="3">{{ $t('words.basic_info') }}</td>
                                <td>{{ $t('words.contract_info') }}</td>
                                <td colspan="2"><i class="icon icon-close"></i></td>
                                <td colspan="2"><i class="icon icon-check"></i></td>
                                <td colspan="2"><i class="icon icon-check"></i></td>
                                <td colspan="2"><i class="icon icon-check"></i></td>
                            </tr>
                            <tr>
                                <td>{{ $t('words.service_account') }}</td>
                                <td colspan="2"><i class="icon icon-close"></i></td>
                                <td><i class="icon icon-check"></i></td>
                                <td><i class="icon icon-close"></i></td>
                                <td><i class="icon icon-check"></i></td>
                                <td><i class="icon icon-close"></i></td>
                                <td colspan="2"><i class="icon icon-check"></i></td>
                            </tr>
                            <tr>
                                <td>{{ $t('words.login_account') }}</td>
                                <td colspan="2"><i class="icon icon-close"></i></td>
                                <td colspan="2"><i class="icon icon-check"></i></td>
                                <td colspan="2"><i class="icon icon-check"></i></td>
                                <td colspan="2"><i class="icon icon-check"></i></td>
                            </tr>
                            <tr>
                                <td colspan="2">{{ $t('words.media_profile_groups') }}</td>
                                <td colspan="2"><i class="icon icon-close"></i></td>
                                <td><i class="icon icon-check"></i></td>
                                <td><i class="icon icon-close"></i></td>
                                <td><i class="icon icon-check"></i></td>
                                <td><i class="icon icon-close"></i></td>
                                <td colspan="2"><i class="icon icon-check"></i></td>
                            </tr>
                            <tr>
                                <td colspan="2">{{ $t('words.member_manage') }}</td>
                                <td colspan="2"><i class="icon icon-close"></i></td>
                                <td colspan="2"><i class="icon icon-close"></i></td>
                                <td colspan="2"><i class="icon icon-close"></i></td>
                                <td colspan="2"><i class="icon icon-check"></i></td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import GlobalConfigMixin from '../mixin/GlobalConfigMixin';

export default {
    mixins: [
        GlobalConfigMixin,
    ],
    data() {
        return {
            members: {
                data: [],
                load: false,
            },
            list_conditions: {
                keyword: '',
                live_status: '',
                shared_status: '',
                order: 'id_desc',
                page: 1,
            },
            channels: {
                links: {
                    prev: null,
                    next: null,
                },
                data: [],
                meta: {
                    last_page: 0,
                    current_page: 1,
                    total: 0,
                    per_page: 0,
                },
                load: false,
            },
            roles: {

            },
        };
    },
    mounted() {
        if (this.loadedServiceAccount) {
            this.initialize();
        }
    },
    methods: {
        initialize() {
            this.loadMembers(this.membersApiUri);
            this.loadChannels(this.channelsApiUri);
        },
        changeOrder(order) {
            this.list_conditions.order = order;
            this.loadChannels(this.channelsApiUri);
        },
        loadChannels(channelApi) {
            this.channels.load = false;
            axios.get(channelApi).then((response) => {
                this.channels = response.data;
                this.list_conditions.page = this.channels.meta.current_page;
                this.channels.load = true;
            });
        },
        loadMembers(membersApiUri) {
            this.members.load = false;
            axios.get(membersApiUri).then((response) => {
                this.members = response.data;
                this.members.load = true;
                this.roles = response.data.meta[0].roles;
            });
        },
        findRoleName(roleId) {
            const role = _.find(this.roles, item => (item.id === roleId));

            return role.name;
        },
        doChangeRole(member) {
            axios.put(`${this.membersApiUri}/${member.id}`, {
                role: member.role_id,
            }).then((response) => {
                this.$toasted.success(this.$t('paragraphs.message.success.update'));
            }).catch((error) => {
                self.$toasted.error(this.$t('paragraphs.message.error.update'));
            });
        },
        doRemove(member) {
            axios.delete(`${this.membersApiUri}/${member.id}`).then((response) => {
                this.$toasted.success(this.$t('paragraphs.message.success.remove'));
                this.loadMembers(this.membersApiUri);
            }).catch((error) => {
                self.$toasted.error(this.$t('paragraphs.message.error.remove'));
            });
        },
    },
    computed: {
        channelsApiUri() {
            return `/cms/${this.selectedServiceAccount.key}/channels_creators` +
                `?order=${this.list_conditions.order}&keyword=${this.list_conditions.keyword}&live_status=${this.list_conditions.live_status}` +
                `&shared_status=${this.list_conditions.shared_status}&page=${this.list_conditions.page}`;
        },
        membersApiUri() {
            return `/cms/${this.selectedServiceAccount.key}/members`;
        },
        getExportUri() {
            let apiLoc = `/cms/${this.selectedServiceAccount.key}/channels_creators/export`;
            apiLoc += `?order=${this.list_conditions.order}`;

            return apiLoc;
        },
    },
    watch: {
        loadedServiceAccount(newValue) {
            this.initialize();
        },
    },
};
</script>

<style scoped>

</style>
